import React, { useRef, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  GenericPdfDownloader,
  schedulePolicyRepayment,
} from "../../../utils/helpers/functions";
import moment from "moment/moment";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";

const PreviewPolicyAppSchedule = ({
  modal_id,
  edit,
  data,
  policyDetails,
  setPartPremium = () => {},
}) => {
  const navigate = useNavigate();
  const close = useRef();
  const repaymentRef = useRef();
  const [scheduleRepayment, setScheduleRepayment] = useState(null);

  // print table to pdf
  const generatePDF = useReactToPrint({
    content: () => repaymentRef.current,
    documentTitle: "Payment Schedule",
  });

  useEffect(() => {
    if (data) {
      let schedule = schedulePolicyRepayment(
        data?.effective_date,
        data?.end_date,
        data?.repayment_frequency,
        data?.but_charge || data?.total_annual_premium
      );
      setScheduleRepayment(schedule);
      setPartPremium(schedule[0]?.amount);
    }
  }, [data]);

  return (
    <>
      <div
        className='modal fade'
        id={modal_id}
        data-bs-backdrop='static'
        data-bs-keyboard='false'
        tabIndex='-1'
        aria-labelledby='staticBackdropLabel'
        aria-hidden='true'
      >
        <div
          className='modal-dialog modal-dialog-scrollable'
          role='document'
          style={{ maxWidth: "650px" }}
        >
          <div className='modal-content rounded-4'>
            <div className='modal-header'>
              <h4 className='modal-title text-primary-1' id='myLargeModalLabel'>
                Premium Payment Schedule
              </h4>
              <span
                type='button'
                className=' bg-gray hover rounded-circle border-none'
                data-bs-dismiss='modal'
                aria-hidden='true'
                ref={close}
                onClick={() =>
                  navigate(`${edit ? "" : "/admin/customer-policy-view"}`, {
                    replace: true,
                    state: {
                      policy_id: data?.policy_id,
                      policyAppNumber: policyDetails?.policyAppNumber,
                      customerId: policyDetails?.customerId,
                    },
                  })
                }
                style={{ padding: "0px 3px" }}
              >
                <i
                  className='mdi mdi-close text-white'
                  style={{ fontSize: "16px" }}
                ></i>
              </span>
            </div>

            <div className='modal-body d-none'>
              <div className='m-3' ref={repaymentRef}>
                <div className='row px-2' id='repaymentRef'>
                  <div className='col-md-11'>
                    <div className='row'>
                      <div className='col-md-6' style={{ fontSize: "12px" }}>
                        <span className='fw-bold me-2 '>Customer ID:</span>
                        <span>{data?.customer_id}</span>
                      </div>
                      <div className='col-md-6' style={{ fontSize: "12px" }}>
                        <span className='fw-bold me-2 '>Policy ID:</span>
                        <span>
                          {data?.policy_app_number ||
                            policyDetails?.policyAppNumber}
                        </span>
                      </div>
                      <div className='col-md-6' style={{ fontSize: "12px" }}>
                        <span className='fw-bold me-2'>Office:</span>
                        <span className='text-capitalize'>
                          {data?.office_name || policyDetails?.office_name}
                        </span>
                      </div>
                      <div className='col-md-6' style={{ fontSize: "12px" }}>
                        <span className='fw-bold me-2'>Customer Name:</span>
                        <span>
                          {data?.customer_name ||
                            policyDetails?.customerFirstName +
                              " " +
                              policyDetails?.customerLastName}
                        </span>
                      </div>
                      <div className='col-md-6' style={{ fontSize: "12px" }}>
                        <span className='fw-bold me-2'> Marketer/Agent:</span>
                        <span className='text-capitalize'>
                          {data?.agent_name ||
                            policyDetails?.agentLastName +
                              " " +
                              policyDetails?.agentFirstName}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className='row mt-3'>
                    <div
                      className='mx-2 pt-1 text-center border'
                      style={{ fontSize: "11px", maxWidth: "95.5%" }}
                    >
                      PREMIUM PAYMENT BREAKDOWN
                    </div>
                    <div className='col-md-12' style={{ fontSize: "12px" }}>
                      <table class='table table-bordered schedule-table '>
                        <thead
                          class='thead-blue'
                          style={{
                            backgroundColor: "#727CF5",
                            textAlign: "center",
                            color: "#FFFFFF",
                          }}
                        >
                          <tr>
                            <th scope='col'>Date</th>
                            <th scope='col'>Premium (&#8358;)</th>
                          </tr>
                        </thead>
                        <tbody style={{ textAlign: "center" }}>
                          {scheduleRepayment?.map((schedule, i) => {
                            return (
                              <tr key={i}>
                                <td>{moment(schedule.date).format("D-M-Y")}</td>
                                <td>{schedule?.amount}</td>
                              </tr>
                            );
                          })}
                          <tr>
                            {data?.repayment_frequency === "one-off" ? (
                              <td className='fw-bold'>
                                {moment(new Date()).format("D-M-Y")}
                              </td>
                            ) : (
                              <td className='fw-bold'>Total</td>
                            )}
                            <td className='fw-bold'>
                              {data?.but_charge ||
                                data?.total_annual_premium?.toFixed(2)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='modal-body'>
              <div className=''>
                <div className='row px-2'>
                  <div className='col-md-12'>
                    <div className='row'>
                      <div className='col-md-6 mb-2'>
                        <span className='fw-bold me-2 '>Customer ID:</span>
                        <span>{data?.customer_id}</span>
                      </div>
                      <div className='col-md-6 mb-2'>
                        <span className='fw-bold me-2 '>Policy ID:</span>
                        <span>
                          {data?.policy_app_number ||
                            policyDetails?.policyAppNumber}
                        </span>
                      </div>
                      <div className='col-md-6 mb-2'>
                        <span className='fw-bold me-2'>Office:</span>
                        <span className='text-capitalize'>
                          {data?.office_name || policyDetails?.office_name}
                        </span>
                      </div>
                      <div className='col-md-6 mb-2'>
                        <span className='fw-bold me-2'>Customer Name:</span>
                        <span className='text-capitalize'>
                          {data?.customer_name ||
                            policyDetails?.customerFirstName +
                              " " +
                              policyDetails?.customerLastName}
                        </span>
                      </div>
                      <div className='col-md-6 mb-2'>
                        <span className='fw-bold me-2'> Marketer/Agent:</span>
                        <span className='text-capitalize'>
                          {data?.agent_name ||
                            policyDetails?.agentLastName +
                              " " +
                              policyDetails?.agentFirstName}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className='row mt-3'>
                    <div
                      className='mx-2 py-1 text-center border '
                      style={{ maxWidth: "96.5%" }}
                    >
                      PREMIUM PAYMENT BREAKDOWN
                    </div>
                    <div className='col-md-12'>
                      <table class='table table-bordered"'>
                        <thead
                          class='thead-blue'
                          style={{
                            backgroundColor: "#727CF5",
                            textAlign: "center",
                            color: "#FFFFFF",
                          }}
                        >
                          <tr>
                            <th scope='col'>Date</th>
                            <th scope='col'>Premium (&#8358;)</th>
                          </tr>
                        </thead>
                        <tbody style={{ textAlign: "center" }}>
                          {scheduleRepayment?.map((schedule, i) => {
                            return (
                              <tr key={i}>
                                <td>{moment(schedule.date).format("D-M-Y")}</td>
                                <td>{schedule?.amount}</td>
                              </tr>
                            );
                          })}
                          <tr>
                            {data?.repayment_frequency === "one-off" ? (
                              <td className='fw-bold'>
                                {moment(new Date()).format("D-M-Y")}
                              </td>
                            ) : (
                              <td className='fw-bold'>Total</td>
                            )}
                            <td className='fw-bold'>
                              {data?.but_charge ||
                                data?.total_annual_premium?.toFixed(2)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='modal-footer me-3'>
              <GenericPdfDownloader
                rootElementId={"repaymentRef"}
                downloadFileName='repayment schedule'
              />
              <button
                type='button'
                className='btn btn-primary btn-sm rounded-3'
                onClick={generatePDF}
              >
                Print
              </button>
              <button
                type='button'
                className='btn btn-success btn-sm rounded-3'
                onClick={() => {
                  close?.current?.click();
                  navigate(`${edit ? "" : "/admin/customer-policy-view"}`, {
                    replace: true,
                    state: {
                      policyAppNumber: policyDetails?.policyAppNumber,
                      customerId: policyDetails?.customerId,
                    },
                  });
                }}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PreviewPolicyAppSchedule;
